var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[( _vm.$route.name&&_vm.$route.name != 'test'&&_vm.$route.name != 'vr'&&_vm.$route.name !='ccwc')?_c('vheader'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }